<template>
  <QmulusButtonGroup>
    <ToggleButton
      v-for="(buttonProp, value) in props.choices"
      :key="value"
      v-tooltip="buttonProp.tooltip || undefined"
      class="radio-button-group"
      :class="{
        'icon-only': iconOnly,
      }"
      :model-value="props.modelValue === value"
      :on-icon="typeof buttonProp.icon === 'string'
        ? buttonProp.icon
        : undefined"
      :off-icon="typeof buttonProp.icon === 'string'
        ? buttonProp.icon
        : undefined"
      :title="buttonProp.label"
      :on-label="props.iconOnly ? '' : buttonProp.label"
      :off-label="props.iconOnly ? '' : buttonProp.label"
      :disabled="props.disabled || buttonProp.disabled"
      :pt="{
        label: {
          style: buttonProp.labelStyle,
        },
      }"
      @click="emit('update:modelValue', value)"
    >
      <template
        v-if="typeof buttonProp.icon === 'object'"
        #icon
      >
        <component :is="buttonProp.icon" />
      </template>
    </ToggleButton>
  </QmulusButtonGroup>
</template>

<script setup lang="ts">
import ToggleButton from '@NitrexGroup/primevue/togglebutton';

import QmulusButtonGroup from './qmulus-button-group.vue';
import {
  IRadioButtonProps,
  IRadioButtonValue,
} from './radio-button-group';

const props = defineProps<{
  choices: IRadioButtonProps<IRadioButtonValue>,
  modelValue: IRadioButtonValue,
  disabled?: boolean,
  iconOnly?: boolean,
}>();
const emit = defineEmits([
  'update:modelValue',
]);
</script>

<style lang="scss" scoped>
.radio-button-group {
  svg {
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
  }
}

.radio-button-group.icon-only {
  svg {
    margin-right: 0;
  }
}
</style>
